import JobCRUD from "./JobCRUD";
import ResponsibilityCRUD from "./ResponsibilityCRUD";
import Stack from "./Stack";
import LayoutWithNav from "./LayoutWithNav";
import PageHeader from "./PageHeader";
import { CircleCheck } from "lucide-react";

export default function TasksPage() {
  return (
    <LayoutWithNav>
      <PageHeader icon={<CircleCheck className="w-6 h-6" />}>Tasks</PageHeader>
      <Stack>
        <JobCRUD />
        <ResponsibilityCRUD />
      </Stack>
    </LayoutWithNav>
  );
}
